<template>
  <el-row type="flex" justify="center" align="middle" style="height: 100vh;background-color: #eee;">
    <el-col :xs="24" :sm="12" :md="8" :lg="6">
      <el-card class="box-card" >
        <div class="clearfix">
          <h2>欢迎使用金宸后台管理系统</h2>
        </div>
        <el-tabs v-model="activeName" >
          <el-tab-pane label="密码登录" name="first">
            <el-form :model="loginForm" ref="loginForm" :rules="loginRules" label-width="60px">
            <el-form-item label="账号" prop="username">
              <el-input v-model="loginForm.username" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input type="password" v-model="loginForm.password" show-password autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">登录</el-button>
            </el-form-item>
          </el-form>

          </el-tab-pane>
          <el-tab-pane label="扫码登录" name="second">
              <h3 style="text-align: center;margin: .5rem;">速客住联APP扫一扫</h3>
              <div    style="width: 100%; height: 100%" v-show="url!=''">
                
                <el-image
                style="width: 100%; height: 100%"
                :src="url"
                fit="fit">
                </el-image>
                <p style="text-align: center;">{{login_cnt}}</p>
              </div>
              <div v-show="url==''" style="text-align: center;">
                  <p style="margin: 1rem;">点击生成二维码</p>
                  <el-button type="primary" @click="btnCreatqrCodeClick">
                    生成二维码
                  </el-button>
              </div>
             
      
          
          </el-tab-pane>
        </el-tabs>


        




      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import {mapGetters,mapMutations,mapActions,mapState} from 'vuex'
import Qrcode from 'qrcode'
export default {
  data() {
    return {
      logincode:'',
      intervalId:0,
      login_cnt:0,
      activeName: 'second',
      fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
      url: '',
      qrcodeBase64: '', // 存储Base64格式的二维码
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 5, message: '帐号长度不能少于5位', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, message: '密码长度不能少于5位', trigger: 'blur' }
        ]
      }
    }
  },
  // async mounted(){
  //   this.url=await Qrcode.toDataURL("123456789")
  // },
  methods: {
    ...mapMutations('Token',['SET_TOKEN']),
    async btnCreatqrCodeClick() {
     let {code,message,data}=await this.$API.getqrcodebylogin() 
     if(code!=200){
        this.$message.success(message)
        return
     }
     this.logincode=data
     let qrcodeObj={
      code,message,data
     }
     qrcodeObj.code=1
     qrcodeObj.message='SUKE BACKWEB Platform'
     this.url=await Qrcode.toDataURL(JSON.stringify(qrcodeObj))
     this.login_cnt=300
     this.intervalId = setInterval(async () => {
         this.login_cnt--
         if(this.login_cnt==0){
          clearInterval(this.intervalId);
          this.url=''
         }
         if((this.login_cnt%5)==0){
            await this.checkLoginStatus()
         }
      }, 1000);
     // let url=await Qrcode.toDataURL(str)
      //return url
    },
    async checkLoginStatus(){
      let {logincode}=this
      let {code,data}=await this.$API.isqrlogin({logincode}) 
      if(code==200){
           clearInterval(this.intervalId);
             this.url=''
             
            this.SET_TOKEN(data)
            this.$router.push('/')
          
      }else{
        console.log('未登录')
      }
    } ,
    submitForm() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
            // const res=await this.$API.loginbytype({
               
            //         identity_type:'password',
            //         identifier:this.loginForm.username,
            //         credential:this.loginForm.password,
           
            // })
           // this.SET_TOKEN('eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJ0aGlua3BocF9hcHAiLCJpYXQiOjE3NzM4ODQ5MjEsImV4cCI6MTc5OTgwNDkyMSwidWlkIjozfQ.lstx4Bq4L5Au1Y68Sw946OKg5nBOQNOpB4ZE6DNDNHQ')
           // this.$router.push('/')
           

          // 这里可以添加登录请求逻辑，比如调用axios发送请求
          //console.log('登录成功，账号：')
          // 登录成功后可跳转页面，示例：this.$router.push('/home')
        } else {
          console.log('登录失败，请检查输入信息')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.clearfix {
  text-align: center;
  margin-bottom: 20px;
}
h2 {
  margin: 0;
  color: #303133;
}
.el-form-item {
  margin-bottom: 20px;
}
.el-button {
  width: 100%;
}
.box-card {
    width: 380px;
    padding: 30px;
    }
</style>
